<!-- 机模配 -->
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/process/stability/params/page"
        getKey="rows" :columns="columns">
      <template #conditions>
        <!--        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
                  <el-form-item :label="$t('mubandianbianma')">
                    <el-input v-model="yt.conditions.code"></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button @click="yt.get(1)" type="primary" plain="plain">
                      {{$t("sousuo")}}
                    </el-button>
                    <el-button
                        @click="
                        yt.clear(
                          (conditions = {
                            equipmentId: $attrs.equipment.id,
                            pageSize: 10,
                            orderBy: 'createTime desc',
                          })
                        )
                      "
                    >{{$t("chongzhi")}}
                    </el-button>
                    <yi_curd_expand_button></yi_curd_expand_button>
                  </el-form-item>
                </el-form>-->
      </template>
      <!-- 左侧按钮插槽 -->
      <template #conditions>
        <!--        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
                  {{$t('xinzeng')}}
                </el-button>-->
        <div class="container">
          <div class="form-container">
            <el-form ref="form" :rules="rules" :model="form" :inline="true" :label-width="formLabelWidth"
                size="mini">
              <el-form-item :label="$t('quanjugongcha')" prop="item3">
                <el-select v-model="form.item3" @change="changeAllDeviation">
                  <el-option v-for="(item, index) in deviation" :key="index" :label="item.label" :value="item.value"/>
                </el-select>
              </el-form-item>
              <el-button :disabled="isButtonDisabled" size="mini" @click="yt.req('POST','/web/process/stability/params/batchUpdate',beforeBatchUpdate,afterAddOrUpdate)" type="primary">
                {{$t('queding')}}
              </el-button>

              <el-button size="mini" @click="yt.req('POST','/web/process/stability/params/initEquipmentparams',beforeBatchUpdate,afterAddOrUpdate)" type="primary">
                {{$t('chushihuaguanjiancanshu')}}
              </el-button>
            </el-form>
          </div>
        </div>
      </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
                type="text"
                @click="yt.showEditDialog('bianji', scope.row);"
            >
              {{$t("bianji")}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger"
                @click="yt.remove(scope.row,'/web/process/stability/params/delete')">{{$t("shanchu")}}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <template #shipeidunwei="scope">
        {{
          scope.row.tonnageMin != null && scope.row.tonnageMax != null ? scope.row.tonnageMin + "-" + scope.row.tonnageMax : ""
        }}
      </template>
      <template #shipeijitai="scope">
        {{scope.row.equipmentObjects | getEquipmentName}}
      </template>
      <template #biaozhunzhouqimiaomo="scope">
        {{scope.row.cycle / 1000}}
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="false" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shujumoban')">
              <yi_cross_select :max="1" :component="'admin_data_equipment_template_point'"
                  :ids.sync="yt.conditions.templatePointId">
              </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('cankaozhi')" required="required">
              <el-input v-model="yt.editObj.refValue" style="width: 30%;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shangpiancha')" required="required">
              <el-input v-model="yt.editObj.upperLimit" style="width: 30%;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xiapiancha')" required="required">
              <el-input v-model="yt.editObj.lowerLimit" style="width: 30%;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('gongchabili')" required="required">
              <el-input v-model="yt.editObj.percent" style="width: 30%;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifouqiyong')" required="required">
              <el-select v-model="yt.editObj.enabled">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button :loading="store.state.global_loading" size="mini"
              @click="yt.req('POST','/web/process/stability/params/create',beforeAdd)" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>

      <!-- 编辑表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="false" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('mubandian')">
              <el-input v-model="yt.editObj.templatePoint.desc" style="width: 30%;" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('cankaozhi')" required="required">
              <el-input v-model="yt.editObj.refValue" style="width: 30%;"></el-input>
            </el-form-item>
<!--            <el-form-item :label="$t('shangpiancha')" required="required">
              <el-input v-model="yt.editObj.upperLimit" style="width: 30%;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xiapiancha')" required="required">
              <el-input v-model="yt.editObj.lowerLimit" style="width: 30%;"></el-input>
            </el-form-item>-->
            <el-form-item :label="$t('gongchabili')" required="required">
              <el-input v-model="yt.editObj.percent" style="width: 30%;" oninput="value=value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifouqiyong')" required>
              <el-switch v-model="yt.editObj.enabled"></el-switch>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button :loading="store.state.global_loading" size="mini"
              @click="yt.req('POST','/web/process/stability/params/update')" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>


    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  components: {},
  name: "web_equipment_process_stability_params",
  data() {
    return {
      form: {
        name: '',
        equipmentId: '',
        modelId: '',
        productId: '',
        remark: '',
        files: [],
        craftGuideParams: [],
        item3: ''
      },
      columns: [
        {
          label: "mubandian",
          prop: "templatePoint.desc",
          width: 150,
        },
        {
          label: "danwei",
          prop: "templatePoint.unit",
          width: 50,
        },
        {
          label: "cankaozhi",
          prop: "refValue",
        },

        {
          label: "gongchabili",
          prop: "percent",
        },
        {
          label: "shifouqiyong",
          prop: "enabled",
          type: "bool",
          iln18: ["shi", "fou"],
        }, {
          label: 'caozuo',
          type: 'slot',
          width: 100,
          fixed: 'right'
        }
      ],
      deviation: [
        { label: '', value: '' }, // 空选项
        ...Array.from({length: 21}, (_, i) => ({
          label: `${i}%`,
          value: i,
        })).slice(1), // 去掉第一个元素 "0%"
      ],
    };
  },
  created() {
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        equipmentId: this.$attrs.equipment.id,
        pageSize: 10,
        orderBy: "createTime desc",
      };
      this.yt.get(1);
    }, 300);
  },
  computed: {
    isButtonDisabled() {
      // 如果 el-select 的值不为空，按钮可用；否则，按钮被禁用
      return !this.form.item3;
    },
  },
  filters: {
    getEquipmentName(value) {
      return value
          .map((item) => {
            return item.name;
          })
          .join(",");
    },
  },
  methods: {
    setDefaultValue(action) {
      this.yt.editObj.cavity = 1;
      this.yt.editObj.cycle = 1;
      this.yt.editObj.enabled = true;
    },
    beforeAdd(params, url) {
      params.equipmentId = this.$attrs.equipment.id;
      if (params.equipmentId != undefined && params.equipmentId != null) {
        params.equipmentId = params.equipmentId.toString();
      }
      params.percent = this.form.item3;
      return params;
    },
    beforeBatchUpdate(params, url) {
      params.equipmentId = this.$attrs.equipment.id;
      if (params.equipmentId != undefined && params.equipmentId != null) {
        params.equipmentId = params.equipmentId.toString();
      }
      params.percent = this.form.item3;
      return params;
    },
    afterAddOrUpdate() {
      this.yt.get(1);
    },
  },
};
</script>

<style scoped lang="scss">
.shift {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
